import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["wrapperStyles", "showSkeleton", "totalVariant", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { CartContent as SharedCartContent, useCartContentCtx } from '~shared/segments/Cart';
import { useCartTotalHeight } from '../hooks/useCartTotalHeight';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Wrapper for the content of the expanded/open cart (order items & summary).
 * Can be used in both desktop and mobile cart.
 */
export var CartContent = function CartContent(_ref) {
  var _wrapperStyles$paddin;

  var wrapperStyles = _ref.wrapperStyles,
      _ref$showSkeleton = _ref.showSkeleton,
      showSkeleton = _ref$showSkeleton === void 0 ? false : _ref$showSkeleton,
      _ref$totalVariant = _ref.totalVariant,
      totalVariant = _ref$totalVariant === void 0 ? "regular" : _ref$totalVariant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var order = useCartContentCtx();
  var cartTotalPadding = (_wrapperStyles$paddin = wrapperStyles === null || wrapperStyles === void 0 ? void 0 : wrapperStyles.padding) !== null && _wrapperStyles$paddin !== void 0 ? _wrapperStyles$paddin : "none"; // used to recalculate the sticky total height

  var recalculateCartTotalHeight = React.useMemo(function () {
    if (totalVariant !== "sticky") return null;
    return {
      order: order,
      showSkeleton: showSkeleton
    };
  }, [order, showSkeleton, totalVariant]);

  var _useCartTotalHeight = useCartTotalHeight({
    cartTotalPadding: cartTotalPadding,
    recalculateCartTotalHeight: recalculateCartTotalHeight
  }),
      cartTotalHeight = _useCartTotalHeight.cartTotalHeight,
      refStickyCartTotal = _useCartTotalHeight.refStickyCartTotal;

  return /*#__PURE__*/_jsx(SharedCartContent, _objectSpread({
    wrapperStyles: wrapperStyles,
    showSkeleton: showSkeleton,
    totalVariant: totalVariant,
    cartTotalHeight: cartTotalHeight,
    refStickyCartTotal: refStickyCartTotal
  }, props));
};